import httpClient from "./httpClient";

const PatientService = {
  async findByAnnouncement(announcementId) {
    const response = await httpClient.get(`/patient/get-by-announcement/${announcementId}`);
    return response.data;
  },

  async create(entity) {
    return await httpClient.post("/patient", entity);
  },

  async update(id, entity) {
    return await httpClient.put(`/patient/${id}`, entity);
  }
};

export default PatientService;
